import http from 'apis/config/http-service';
import { useCallback } from 'react';

const endpoint = 'api/v1/cms/supplier-profiles/available-suppliers';

type TOption = {
  value: number;
  label: string;
};

interface AvailableSupplierDto {
  id: number;
  name: string | null;
}

export function useSearchAvailableSuppliersApi() {
  const loadOptions = useCallback((inputValue: string, callback: (options: TOption[]) => void) => {
    if (inputValue.length < 2) {
      callback([]);
      return;
    }

    http
      .get(endpoint, {
        params: {
          name: inputValue,
        },
      })
      .then((res) => {
        const options: TOption[] = (res?.data?.data || []).map((item: AvailableSupplierDto) => ({
          value: item.id,
          label: item.name ?? `Supplier #${item.id}`,
        }));
        callback(options);
      })
      .catch(() => callback([]));
  }, []);

  return { loadOptions };
}
